import React from 'react';
import { Tooltip } from 'antd';
import Icon from '../../../../Icon';
import Skeleton from './skeleton';
import countriesMapping from "../../../../Utils/countriesMapping";
import './styles.less';

function tooltipHandler({ data, mapping }) {

  return (
    <Tooltip
      title={data.map((el) => mapping ? el?.[mapping] : el).join(', ').replaceAll('_', ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}
      placement={'top'}
      overlayClassName={'more-options-tooltip'}
    >
      <span className={'more-options'}>{data.length}</span>
    </Tooltip>
  );
}

function valueHandler({ object, type, countries }) {
  if (type === 'region') {
    const city = object?.city;
    const region = object?.region;
    const country = object?.country;
    return [city, region, country].filter(Boolean).join(', ') || '-';
  }
  if (type === 'localization') {
    if (object?.length) {
      if (object?.length <= 3) {
        return object?.map((el) => el?.endonymName).join(', ');
      } else {
        const [a, b, c, ...rest] = object;
        return (
          <>
            {[a, b, c]?.map((el) => el?.endonymName).join(', ')}
            {tooltipHandler({
              data: rest,
              mapping: 'endonymName',
            })}
          </>
        );
      }
    } else return '-';
  }
  if (type === 'shipping') {
    if (object?.length) {
      if (object?.length <= 3) {
        return (
          <>
            {
              object?.map((el) => (
                <Tooltip title={countries?.[el]?.name} placement={'top'}>
                  <span className="flag-icon"
                        dangerouslySetInnerHTML={{ __html: countries?.[el]?.flag }}
                  />
                </Tooltip>
              ))
            }
          </>
        )
      } else {
        const [a, b, c, ...rest] = object;
        return (
          <>
            {
              [a,b,c]?.map((el) => (
                <Tooltip title={countries?.[el]?.name} key={countries?.[el]?.name} placement={'top'}>
                  <span className="flag-icon"
                        dangerouslySetInnerHTML={{ __html: countries?.[el]?.flag }}
                  />
                </Tooltip>
              ))
            }
            {tooltipHandler({
              data: rest.map(el => countries?.[el]?.name) || [],
              mapping: false,
            })}
          </>
        )
      }
    } else return '-';
  }
  if (type === 'currencies') {
    if (object?.length) {
      if (object?.length <= 3) {
        return object?.join(', ');
      } else {
        const [a, b, c, ...rest] = object;
        return (
          <>
            {[a, b, c]?.map((el) => el?.endonymName ? Boolean(el?.endonymName) : el).join(', ')}
            {tooltipHandler({
              data: rest,
              mapping: false,
            })}
          </>
        );
      }
    } else return '-';
  }
  if (type === 'methods') {
    if (object?.length) {
      if (object?.length <= 3) {
        return (
          <>
            {
              object?.map((el) => (
                <Tooltip key={el?.toLowerCase()} title={el?.toLowerCase().replaceAll('_', ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())} placement={'top'}>
                  <span className="payment-icon">
                    <Icon role={'icon'} type={`payment_${el?.toLowerCase()}`} />
                  </span>
                </Tooltip>
              ))
            }
          </>
        )
      } else {
        const [a, b, c, ...rest] = object;
        return (
          <>
            {
              [a,b,c]?.map((el) => (
                <Tooltip key={el} title={el?.toLowerCase().replaceAll('_', ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())} placement={'top'}>
                  <span className="payment-icon">
                    <Icon role={'icon'} type={`payment_${el?.toLowerCase()}`} />
                  </span>
                </Tooltip>
              ))
            }
            {tooltipHandler({
              data: rest.map(el => el?.toLowerCase()),
              mapping: false,
            })}
          </>
        )
      }
    } else return '-';
  }
  if (type === 'cards') {
    if (object?.length) {
      if (object?.length <= 3) {
        return (
          <>
            {
              object?.map((el) => {
                const iconType = `card_${el?.toLowerCase()}`;

                return (
                  <Tooltip key={iconType} title={el?.toLowerCase().replaceAll('_', ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())} placement={'top'}>
                  <span className="payment-icon">
                    <Icon role={'icon'} type={iconType} />
                  </span>
                  </Tooltip>
                )
              })
            }
          </>
        )
      } else {
        const [a, b, c, ...rest] = object;
        return (
          <>
            {
              [a,b,c]?.map((el) => (
                <Tooltip title={el?.toLowerCase().replaceAll('_', ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())} placement={'top'}>
                  <span className="payment-icon">
                    <Icon role={'icon'} type={`card_${el?.toLowerCase()}`} />
                  </span>
                </Tooltip>
              ))
            }
            {tooltipHandler({
              data: rest.map(el => el?.toLowerCase()),
              mapping: false,
            })}
          </>
        )
      }
    } else return '-';
  }
}

const StoreInformation = ({ skeleton, result }) => {

  const dataToDisplay = [
    {
      name: 'Merchant name',
      value: result?.metaData?.name || '-',
    },
    {
      name: 'Region',
      value: valueHandler({
        object: result?.metaData,
        type: 'region',
      }),
    },
    {
      name: 'Store localization',
      value: valueHandler({
        object:
          result?.paymentData?.localization?.availableLanguages,
        type: 'localization',
      }),
    },
    {
      name: 'Ship to',
      value: valueHandler({
        object: result?.paymentData?.shop?.shipsToCountries,
        countries: countriesMapping,
        type: 'shipping'
      }),
    },
    {
      name: 'Privacy Policy',
      value: result?.paymentData?.shop?.privacyPolicy?.url,
      link: true,
    },
    {
      name: 'Shipping Policy',
      value: result?.paymentData?.shop?.shippingPolicy?.url,
      link: true,
    },
    {
      name: 'Store currency',
      value: result?.metaData?.currency || '-',
    },
    {
      name: 'Supported currencies',
      value: valueHandler({
        object: result?.paymentData?.paymentSettings?.enabledPresentmentCurrencies,
        type: 'currencies',
      }),
    },
    {
      name: 'Supported payment methods',
      value: valueHandler({
        object: result?.paymentData?.paymentSettings?.supportedDigitalWallets?.length ? [...result?.paymentData?.paymentSettings?.supportedDigitalWallets, 'PAY_PAL'] : ['PAY_PAL'],
        type: 'methods'
      }),
    },
    {
      name: 'Supported card brands',
      value: valueHandler({
        object: result?.paymentData?.paymentSettings?.acceptedCardBrands,
        type: 'cards'
      }),
    },
    {
      name: 'PayPal merchant id',
      value: result?.paymentData?.paymentsConfig?.paymentInstruments?.paypalConfig?.merchantId
    },
  ];

  if (skeleton) return <Skeleton />;

  return (
    <div className="overview-block store-information">
      <div className="title">Store information</div>
      <div className="info-wrapper">
        {dataToDisplay.map((el) => (
          <div key={el?.name} className="info-item">
            <div className="info-item-title">{el?.name}</div>
            <div className="info-item-value">
              {el?.link ? (
                <span onClick={() => window.open(el?.value, '_blank')}>
                  View <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6.16667 2.5H4.63333C3.8866 2.5 3.51323 2.5 3.22801 2.64532C2.97713 2.77316 2.77316 2.97713 2.64532 3.22801C2.5 3.51323 2.5 3.8866 2.5 4.63333V11.3667C2.5 12.1134 2.5 12.4868 2.64532 12.772C2.77316 13.0229 2.97713 13.2268 3.22801 13.3547C3.51323 13.5 3.8866 13.5 4.63333 13.5H11.3667C12.1134 13.5 12.4868 13.5 12.772 13.3547C13.0229 13.2268 13.2268 13.0229 13.3547 12.772C13.5 12.4868 13.5 12.1134 13.5 11.3667V9.83333M9.16667 2.5H13.5M13.5 2.5V6.83333M13.5 2.5L7.33333 8.66667" stroke="#225AEA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </span>
              ) : (
                el?.value
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StoreInformation;
